import { Helmet } from 'react-helmet-async'

interface SEOProps {
  title: string
  description: string
  canonical?: string
  image?: string
  jsonLd?: object | object[]
  type?: 'website' | 'article'
}

/**
 * Wrapper de SEO para páginas de marketing (SSG-friendly).
 * Renderiza meta tags, OpenGraph, Twitter Card y JSON-LD opcional.
 * Compatible con react-helmet-async: durante el build SSG los tags
 * se extraen del DOM estático, durante runtime se actualizan en cliente.
 */
export function SEO({
  title,
  description,
  canonical,
  image = 'https://voltary.org/og.png',
  jsonLd,
  type = 'website',
}: SEOProps) {
  const jsonLdArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : []

  return (
    <Helmet>
      <html lang="es" />
      <title>{title}</title>
      <meta name="description" content={description} />
      {canonical && <link rel="canonical" href={canonical} />}

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Voltary" />
      <meta property="og:locale" content="es_ES" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLdArray.map((schema, idx) => (
        <script key={idx} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  )
}
